import { Component, Input } from '@angular/core';
import * as icons from '../../../scss/fundament/ssr-icon/string-icons';
import { compact } from '@imcc/utilities';
import { SvgIconRegistryService } from 'angular-svg-icon';
import { PrefixedClassList } from '../../prefixed-class-list';
import { CUSTOM_STRING_ICONS } from '../custom-string-icons';
import { FontSize } from '../font-size';
import { ICON_SIZE_CLASS_MAP } from '../icon-size-class-map';

/**
 * @property {string} prefix     - The prefix to use for the
 *                                 CSS classes.
 * @property {color} color       - The color of the icon.
 * @property {FontSize} fontSize - Size of the icon.
 * @property {string} icon       - The icon to use.
 *
 * @export
 * @class IconComponent
 */
@Component({
  selector: 'app-fm-icon',
  templateUrl: './icon.component.html',
})
export class IconComponent {
  @Input()
  prefix = '';

  @Input()
  color = 'black';

  @Input()
  icon = '';

  @Input()
  fontSize: FontSize = FontSize.Small;

  constructor(private iconReg: SvgIconRegistryService) {}

  get iconClass(): string {
    return new PrefixedClassList(
      this.prefix,
      ...compact(['svg-icon', `svg-icon--${this.color}`, ICON_SIZE_CLASS_MAP[this.fontSize]]),
    ).toString();
  }

  ngOnInit() {
    this.registerIcon();
  }

  private registerIcon() {
    this.iconReg.addSvg(
      this.icon,
      {
        ...CUSTOM_STRING_ICONS,
        ...icons.default(),
      }[this.icon],
    );
  }
}
